// Exports the "textcolor" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/textcolor')
//   ES2015:
//     import 'tinymce/plugins/textcolor'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/plugins/textcolor/index.js
// module id = 2026
// module chunks = 0